(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 87357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@mui/system/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(54695);
// EXTERNAL MODULE: ./node_modules/@mui/system/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(60916);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 4 modules
var styled_engine = __webpack_require__(27052);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx_styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js + 1 modules
var useTheme = __webpack_require__(79718);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createBox.js


const _excluded = ["className", "component"];







function createBox(options = {}) {
  const {
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName,
    styleFunctionSx = styleFunctionSx_styleFunctionSx/* default */.Z
  } = options;
  const BoxRoot = (0,styled_engine/* default */.ZP)('div')(styleFunctionSx);
  const Box = /*#__PURE__*/react.forwardRef(function Box(inProps, ref) {
    const theme = (0,useTheme/* default */.Z)(defaultTheme);

    const _extendSxProp = (0,extendSxProp/* default */.Z)(inProps),
          {
      className,
      component = 'div'
    } = _extendSxProp,
          other = (0,objectWithoutPropertiesLoose/* default */.Z)(_extendSxProp, _excluded);

    return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ref: ref,
      className: (0,clsx_m/* default */.Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: theme
    }, other));
  });
   false ? 0 : void 0;
  return Box;
}
// EXTERNAL MODULE: ./node_modules/@mui/base/className/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(88076);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 14 modules
var createTheme = __webpack_require__(21265);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/Box.js



const defaultTheme = (0,createTheme/* default */.Z)();
/**
 * @ignore - do not document.
 */

const Box = createBox({
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 67077:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(20297);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77297);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66278);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);




var Layout = function(param) {
    var children = param.children, categories = param.categories, seo = param.seo;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "auto"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                flexGrow: 1,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 20297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32283);


var PrivacyPolicy = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "section section--big section--bg-world",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "headline",
                        children: "Gizlilik Politikası"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "generic-content-container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    "Site \xfczerinde oluşturduğunuz CV’niz aktif durumda ise \xfcye firmalarımız veritabanı i\xe7erisinde yaptıkları aramalarda Cv’nize her an ulaşabilirler. Eğer iş arayışınıza ara verdiyseniz ve \xfcye firmaların veritabanı i\xe7inde yaptıkları aramalarda size ulaşmalarını engellemek isterseniz Cv’nizi pasif hale getirebilirsiniz. Cv’nizin pasif olduğu durumda hi\xe7bir \xfcye firma Cv’nize ulaşamaz. Aynı zamanda bu durumlarda kısa bir s\xfcre Cv’nizi aktif ederek dileğiniz ilana başvuru yapabilirsiniz. Dolayısıyla sadece ilanına başvuru yaptığınız firma tarafından Cv’niz incelenecektir.",
                                    " "
                                ]
                            }),
                            "Eğer iskibris.com’da kullandığınız şifrenizin başkası tarafından kullanıldığından ş\xfcphe ediyorsanız şifrenizi değiştirebilirsiniz.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "Kullanıcılara ait bilgiler sadece \xfcye firmalarımız ve ticari ama\xe7larla yasal \xe7er\xe7evede bilgilerinizi paylaştığımız kişi ve kurumlar tarafından g\xf6r\xfclmektedir. Bu sitede paylaştığınız bilgiler \xfcyelerimize iş ve iş\xe7i arayışlarında yardımcı olmak amacıyla ve reklam, tanıtım ve pazarlama amacıyla kullanılmaktadır. Bilgileriniz iş arayışlarında yardımcı olmak amacıyla ve reklam, tanıtım ve pazarlama faaliyetlerinde kullanılmak amacıyla Bankalar vs. 3. Kişilerle paylaşılabilir ve iskibris.com tarafından ve/veya bilgilerin paylaşıldığı kişilerce işlenebilir. Bunun sonucu olarak kişisel bilgileriniz iş ve iş\xe7i arayışlarında ve reklam, tanıtım ve pazarlama faaliyetlerinde kullanılabilir ve bu ama\xe7larla tarafınıza sms, mail, telefon vs. yollardan ulaşılıp bilgilendirme yapılabilir. ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "iskibris.com’da yer alan bilgilerinizi istediğiniz zaman değiştirebilir ve t\xfcm kişisel bilgilerinizin silinmesini ya da bilgilendirme yapılan kanal \xfczerinden, size sms, mail, telefon vs. yollardan ulaşılıp bilgilendirme yapılmamasını sağlayabilirsiniz.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "Yukarıda tarafıma aktarılan bilgileri okudum ve anladım. Bu sitede paylaştığınız bilgilerin İş Kıbrıs tarafından yukarıda sayılan ama\xe7larla, \xdcYE FİRMALAR HARİCİNDE ve \xfc\xe7\xfcnc\xfc kişilerle paylaşılmasını ve bilgilerimin iskibris.com ve uygun g\xf6rd\xfcğ\xfc 3. Kişiler tarafından işlenmesini; ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "iskibris.com’a g\xf6sterdiğiniz ilgi ve g\xfcvene teşekk\xfcr ederiz."
                        ]
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (PrivacyPolicy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [722,795,774,888,179], function() { return __webpack_exec__(67077); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);